import { TmBaseError } from '@/core/error/tmBaseError'

export class TmPreloadError extends TmBaseError {
  public name = 'TmPreloadError'
}
